import { createFileRoute } from '@tanstack/react-router';

import { AssistanceChatPage } from '@/features/assistant/components/chat/AssistanceChatPage';

export const Route = createFileRoute('/_authenticated/assistances/$id')({
	component: AssistanceChatRouteComponent,
});

function AssistanceChatRouteComponent() {
	const { id } = Route.useParams();
	return <AssistanceChatPage assistanceId={id} />;
}
